'use strict';

require('./TextFieldSuggestedList.scss');

const React = require('react'),
    { map } = require('lodash/collection'),
    { union } = require('lodash/array'),
    get = require('lodash/object').get,
    TextFieldSuggestedListItem = require('./TextFieldSuggestedListItem'),
    { PropTypes } = require('react');

const TextFieldSuggestedList = React.createClass({displayName: "TextFieldSuggestedList",
    propTypes: {
        items: PropTypes.array,
        itemsDisabled: PropTypes.array,
        isExpanded: PropTypes.bool,
        readerAttribute: PropTypes.string,
        textWritten: PropTypes.string
    },

    render() {
        const { items, itemsDisabled, isExpanded, readerAttribute, onClick, textWritten } = this.props;
        const allItems = union(items, itemsDisabled);
        const itemsEl = map(allItems, item => {
            return (
                React.createElement(TextFieldSuggestedListItem, {
                    readerAttribute: readerAttribute, 
                    item: item, 
                    matchText: textWritten, 
                    onClick: onClick, 
                    isDisabled: get(item, 'isDisabled')}
                )
            );
        });
        return (
            React.createElement("div", {
                style: {
                    display: isExpanded ? 'block' : 'none'
                }, 
                className: "bp-textfield-suggested-list"
            }, 
                React.createElement("ul", null, 
                    itemsEl
                )
            )
        );
    }
});

module.exports = TextFieldSuggestedList;



/** WEBPACK FOOTER **
 ** ./src/components/Commons/TextField/TextFieldSuggested/TextFieldSuggestedList/TextFieldSuggestedList.jsx
 **/